import React, { useEffect, useState } from 'react';
import { AutoComplete, Button, Input, notification, Spin } from 'antd';
import './ResourceStyle.css';
import { create_video_guide_ActionHandler } from '../../../../Redux/Actions/user/createVideoGuide';
import { useDispatch, useSelector } from 'react-redux';

const UploadVideoGuides = () => {
    const [video, setVideo] = useState(null);
    const [name, setName] = useState('');
    const [nameTouched, setNameTouched] = useState(false);
    const [videoTouched, setVideoTouched] = useState(false);
    let dispatch = useDispatch();
    const loading = useSelector(
        (state) => state.create_video_guide_data.loader
    );

    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file.size > MAX_FILE_SIZE) {
            notification.error({
                message: 'File size exceeds the maximum limit of 20 MB.',
            });
            return;
        }
        setVideo(file);
        setVideoTouched(true);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    useEffect(() => {
        //gtm
        window.dataLayer.push({
            event: 'Video Guillines ',
            buttonName: 'Video Guillines ',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    }, []);

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];

        if (file && isVideoFile(file)) {
            setVideo(file);
            setVideoTouched(true);
        } else {
            alert(
                'Please drop a valid video file (MP4, MOV, AVI, MKV, or WebM).'
            );
        }
    };
    const isVideoFile = (file) => {
        const validTypes = [
            'video/mp4',
            'video/quicktime',
            'video/x-msvideo',
            'video/x-matroska',
            'video/webm',
        ];
        return validTypes.includes(file.type);
    };

    const handleUpload = async (e) => {
        debugger;
        e.preventDefault();
        setNameTouched(true);
        setVideoTouched(true);

        if (!(name ?? '').trim()) {
            notification.error({ message: 'Please enter a video title.' });
            return;
        }

        if (!video) {
            notification.error({ message: 'Please select a video file.' });
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('video', video);

            dispatch(create_video_guide_ActionHandler(formData));

            setName('');
            setVideo('');
            setNameTouched(false);
            setVideoTouched(false);
        } catch (error) {
            console.error('Error uploading video:', error);
        }
    };

    return (
        <div className='main-cont-up'>
            <div>
                <Spin spinning={loading}>
                    <form className='faqForm'>
                        <div className='workspaces-input-field'>
                            <label>Video Title</label>
                            <Input
                                placeholder='Sample'
                                value={name}
                                required
                                onChange={(e) => setName(e.target.value)}
                                onBlur={() => setNameTouched(true)}
                            />
                            {nameTouched && !name.trim() && (
                                <p className='validation-message'>
                                    Please enter a video title.
                                </p>
                            )}
                        </div>

                        <div
                            className='drag-drop mt-22'
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}>
                            <div className='stick'>
                                <p>
                                    Drag & Drop Your file or click to upload
                                    your video (MP4 or WebM files)
                                </p>
                                <span>Or</span>
                                <div className='file-uploader2'>
                                    <label
                                        htmlFor='fileInput'
                                        className='file-label'>
                                        <svg
                                            className='upload-svg'
                                            width='17'
                                            height='18'
                                            viewBox='0 0 17 18'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'>
                                            <path
                                                d='M6.25 12.75V8.25L4.75 9.75'
                                                stroke='white'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M6.25 8.25L7.75 9.75'
                                                stroke='white'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M16 7.5V11.25C16 15 14.5 16.5 10.75 16.5H6.25C2.5 16.5 1 15 1 11.25V6.75C1 3 2.5 1.5 6.25 1.5H10'
                                                stroke='white'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M16 7.5H13C10.75 7.5 10 6.75 10 4.5V1.5L16 7.5Z'
                                                stroke='white'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                        </svg>
                                        Upload form computer
                                    </label>
                                    <input
                                        type='file'
                                        id='fileInput'
                                        onChange={handleFileChange}
                                        required
                                        accept='.mp4, .mov, .avi, .mkv, .webm'
                                        onBlur={() => setVideoTouched(true)}
                                        value=''
                                    />
                                    {video && (
                                        <span className='file-name'>
                                            {video.name}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        {videoTouched && !video && (
                            <p className='validation-message'>
                                Please select a video file.
                            </p>
                        )}

                        <div className='upload'>
                            <button
                                type='submit'
                                className='upload-button'
                                onClick={handleUpload}
                                disabled={loading}>
                                Upload Video
                            </button>
                        </div>
                    </form>
                </Spin>
            </div>
        </div>
    );
};
export default UploadVideoGuides;
